// extracted by mini-css-extract-plugin
export default {"wrapper":"RangeSlider_wrapper__rfCqS","range":"RangeSlider_range__kqNpW","ticks":"RangeSlider_ticks__T4K9x"};